<template>
  <th
    :class="alignClass"
    @click="onSort"
  >
    <button
      :class="alignClass"
      :disabled="!sortable"
    >
      <span>{{ label }}</span>
      <i
        v-show="sortable"
        :class="sortIcon"
      />
    </button>
  </th>
</template>

<script>
export default {
  name: 'MsGridHeaderItem',
  props: {
    property: {
      type: String,
      required: true,
      default: 'Error!'
    },
    label: {
      type: String,
      required: true,
      default: 'Error!'
    },
    sortable: {
      type: Boolean,
      required: false,
      default: true
    },
    currentSort: {
      type: String,
      required: false,
      default: ''
    },
    direction: {
      type: String,
      required: false,
      default: '',
      validate (val) {
        return ['asc', 'desc', ''].indexOf(val.trim().toLowerCase()) > -1
      }
    },
    align: {
      type: String,
      required: false,
      default: 'left'
    }
  },
  computed: {
    alignClass () {
      const alignClasses = {
        left: 'text-left',
        right: 'text-right',
        center: 'text-center'
      }
      return alignClasses[this.align] || alignClasses.left
    },
    sortIcon () {
      if (this.property === this.currentSort) {
        let icons = {
          asc: 'grid-icon-sort-asc',
          desc: 'grid-icon-sort-desc',
          '': 'grid-icon-sort'
        }
        return icons[this.direction]
      }
      return 'grid-icon-sort'
    }
  },
  methods: {
    onSort () {
      this.$emit('onSort', this.property)
    }
  }
}
</script>

<style scoped>
  button {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/modules/grid/ms-grid-header-item.vue